import React from "react";
import { MOBILE_PANEL_MEDIA_QUERY } from "./constants";

export const isInteractiveShortcutTarget = (target) => {
  if (!(target instanceof Element)) return false;
  if (target.closest("[contenteditable='true']")) return true;
  const tagName = target.tagName.toLowerCase();
  return (
    tagName === "input" ||
    tagName === "textarea" ||
    tagName === "select" ||
    tagName === "button" ||
    tagName === "a"
  );
};

export function useIsMobilePanelViewport() {
  const [matches, setMatches] = React.useState(() => {
    if (typeof window === "undefined") return false;
    return window.matchMedia(MOBILE_PANEL_MEDIA_QUERY).matches;
  });

  React.useEffect(() => {
    const mediaQuery = window.matchMedia(MOBILE_PANEL_MEDIA_QUERY);
    const handleChange = () => setMatches(mediaQuery.matches);
    handleChange();
    mediaQuery.addEventListener("change", handleChange);
    return () => mediaQuery.removeEventListener("change", handleChange);
  }, []);

  return matches;
}
